"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The News model module.
 * @module model/News
 * @version 0.0.1
 */
class News {
  /**
   * Constructs a new <code>News</code>.
   * @alias module:model/News
   * @param titel {String} 
   * @param beschreibung {String} 
   * @param link {String} 
   * @param datum {String} 
   */
  constructor(titel, beschreibung, link, datum) {
    News.initialize(this, titel, beschreibung, link, datum);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, titel, beschreibung, link, datum) {
    obj['titel'] = titel;
    obj['beschreibung'] = beschreibung;
    obj['link'] = link;
    obj['datum'] = datum;
  }

  /**
   * Constructs a <code>News</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/News} obj Optional instance to populate.
   * @return {module:model/News} The populated <code>News</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new News();
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('link')) {
        obj['link'] = _ApiClient.default.convertToType(data['link'], 'String');
      }
      if (data.hasOwnProperty('datum')) {
        obj['datum'] = _ApiClient.default.convertToType(data['datum'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>News</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>News</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of News.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // ensure the json data is a string
    if (data['link'] && !(typeof data['link'] === 'string' || data['link'] instanceof String)) {
      throw new Error("Expected the field `link` to be a primitive type in the JSON string but got " + data['link']);
    }
    // ensure the json data is a string
    if (data['datum'] && !(typeof data['datum'] === 'string' || data['datum'] instanceof String)) {
      throw new Error("Expected the field `datum` to be a primitive type in the JSON string but got " + data['datum']);
    }
    return true;
  }
}
News.RequiredProperties = ["titel", "beschreibung", "link", "datum"];

/**
 * @member {String} titel
 */
News.prototype['titel'] = undefined;

/**
 * @member {String} beschreibung
 */
News.prototype['beschreibung'] = undefined;

/**
 * @member {String} link
 */
News.prototype['link'] = undefined;

/**
 * @member {String} datum
 */
News.prototype['datum'] = undefined;
var _default = exports.default = News;